import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Button, ButtonVariants } from '@frontend/design-system';
import { HISTORY_TRAY_WIDTH } from '../phone-system-history/history-details-tray/history-details-tray';

export const SeeHistoryButton = ({
  onClick,
  isActive,
  trackingId,
  label,
  variant = 'secondary',
  showLabel = true,
}: {
  onClick: () => void;
  isActive?: boolean;
  trackingId?: string;
  /**
   * Custom label to display instead of the default "See History"/"Hide History" text.
   */
  label?: string;
  /**
   * Button variant. Defaults to 'secondary'.
   */
  variant?: ButtonVariants;
  /**
   * Whether to show the button label text. When false, renders as icon-only with a hover tooltip.
   * Defaults to true.
   */
  showLabel?: boolean;
}) => {
  const { t } = useTranslation('phone');
  const iconName = isActive ? 'view-off-small' : 'history-small';
  const labelText = label ?? (isActive ? t('Hide History') : t('See History'));

  return (
    <Button
      variant={variant}
      iconName={iconName}
      onClick={onClick}
      trackingId={trackingId}
      hoverLabel={!showLabel ? labelText : undefined}
      css={buttonStyle(isActive)}
    >
      {showLabel ? labelText : undefined}
    </Button>
  );
};

const buttonStyle = (isActive?: boolean) => css`
  margin-bottom: var(--fabric-space-gap-sm);

  // Make the button a fixed distance from the right edge of the screen for large screens so that it does not appear
  // like it is floating in the middle of the page. When the history tray is open, move the button to the left so
  // that it does not get covered by the tray.
  // TODO: Uncomment these styles when we no longer use the call out dialog wrapper.
  // @media (min-width: 1660px) {
  //   position: absolute;
  //   right: ${isActive ? `${HISTORY_TRAY_WIDTH + 32}px` : '80px'};
  // }
`;
